/* ==================================================================
   Tubelight-Navigation - der wandernde Teil
   ------------------------------------------------------------------
   Setzt Position und Groesse der Lampe. Mehr passiert hier nicht:
   den weichen Uebergang macht die CSS-Transition, das Aussehen steht
   in bsfa-tubelight.css.

   Drei Eigenheiten des Themes bestimmen den Aufbau:

   1. Die Lampe haengt in .header-menu__inner und NICHT in der
      overflow-list. Die misst ihre eigenen Kinder, um zu entscheiden,
      ob die Leiste in die Schublade klappt - ein zusaetzliches
      Element darin wuerde diese Rechnung verfaelschen.

   2. Shopify reicht die Kopfleiste kurz nach dem ersten Aufbau noch
      einmal durch und wirft dabei alles weg, was nicht aus dem Theme
      stammt - also auch die Lampe. Deshalb wird hier nicht einmal
      aufgebaut, sondern bei jeder Aenderung an der Kopfleiste
      nachgesehen, ob sie noch da ist.

   3. Die Leiste ist NICHT immer einzeilig. Seit ol-kopf.js den
      Sammelpunkt abschaltet, brechen die Menuepunkte auf schmalen
      Fenstern in eine zweite Zeile um. Die Lampe rechnet deshalb
      nicht mit einer festen Zeilenmitte, sondern nimmt die Hoehe des
      Eintrags, wie sie ist.

      Was bleibt, ist eine Plausibilitaetspruefung: liegt der Eintrag
      gerade ausserhalb des Rahmens, wurde in einem Zwischenzustand
      gemessen. Frueher kam das von der overflow-list, die zum Messen
      die Reihe kurz umbrechen liess - die Lampe blieb dann eine
      Zeilenhoehe unter der Kopfleiste haengen, als leuchtender
      Balken mitten auf der Seite. Diese Messerei gibt es nicht mehr,
      die Pruefung bleibt als Sicherung.
   ================================================================== */
(function () {
  'use strict';

  var rahmen = null;
  var liste = null;
  var lampe = null;
  var aktiv = null;
  var nachgereicht = false;

  function sichtbareLinks() {
    if (!liste) return [];
    var alle = liste.querySelectorAll('.menu-list__list-item > .menu-list__link');
    return Array.prototype.filter.call(alle, function (el) {
      // Der letzte Eintrag ist Canyons verstecktes "mehr"-Menue und
      // ein <button>, kein Link - der zaehlt hier nicht mit.
      return el.tagName === 'A' && el.offsetParent !== null;
    });
  }

  // Der Eintrag, auf dessen Seite wir gerade sind. Es gewinnt der
  // laengste passende Pfad, sonst wuerde auf /collections/windows-server
  // auch "Windows" als aktiv gelten.
  function aktuellerLink() {
    var pfad = window.location.pathname.replace(/\/$/, '');
    var bester = null;
    var laenge = 0;
    sichtbareLinks().forEach(function (a) {
      var href = (a.getAttribute('href') || '').split('?')[0].split('#')[0].replace(/\/$/, '');
      if (!href) return;
      if (pfad === href || pfad.indexOf(href + '/') === 0) {
        if (href.length > laenge) {
          laenge = href.length;
          bester = a;
        }
      }
    });
    return bester;
  }

  function stelle(ziel) {
    if (!lampe) return;
    if (!ziel) {
      lampe.removeAttribute('data-an');
      return;
    }
    var r = rahmen.getBoundingClientRect();
    // Hat der Rahmen keine Breite, steht die Leiste gar nicht da -
    // unter 750 px zeigt Canyon die Schublade. Dann bleibt die Lampe
    // aus, statt irgendwo im Layout herumzustehen. Gemessen und nicht
    // an einer Fensterbreite abgelesen: was zaehlt, ist ob die Leiste
    // ueberhaupt sichtbar ist.
    if (!r.width) {
      lampe.removeAttribute('data-an');
      return;
    }
    var z = ziel.getBoundingClientRect();
    if (!z.width) return;

    var oben = z.top - r.top;

    // Plausibilitaetspruefung (siehe Eigenheit 3 oben): der Eintrag
    // muss innerhalb des Rahmens liegen - egal, in welcher Zeile. Tut
    // er das nicht, wurde in einem Zwischenzustand gemessen. Die
    // Messung wird verworfen und im naechsten Bild wiederholt. Ein
    // einziger Nachschlag genuegt; mehr waere eine Schleife.
    if (oben < -2 || z.bottom > r.bottom + 2) {
      if (!nachgereicht) {
        nachgereicht = true;
        window.requestAnimationFrame(function () {
          nachgereicht = false;
          stelle(ziel);
        });
      }
      return;
    }

    lampe.style.width = z.width + 'px';
    lampe.style.height = z.height + 'px';
    lampe.style.transform = 'translate(' + (z.left - r.left) + 'px, ' + oben + 'px)';
    lampe.setAttribute('data-an', '');
  }

  function zurueck() {
    stelle(aktiv);
  }

  function trefferAus(ereignis) {
    var el = ereignis.target;
    if (!el || !el.closest) return null;
    var a = el.closest('.menu-list__list-item > .menu-list__link');
    return a && liste.contains(a) && a.tagName === 'A' ? a : null;
  }

  function bindeEreignisse() {
    liste.addEventListener('pointerover', function (e) {
      var a = trefferAus(e);
      if (a) stelle(a);
    });

    // Das aufgeklappte Untermenue liegt im selben Eintrag, ist also ein
    // Nachfahre der Liste. Deshalb faellt die Lampe nicht zurueck,
    // solange die Maus darin unterwegs ist.
    liste.addEventListener('pointerleave', zurueck);

    liste.addEventListener('focusin', function (e) {
      var a = trefferAus(e);
      if (a) stelle(a);
    });
    liste.addEventListener('focusout', function (e) {
      if (!liste.contains(e.relatedTarget)) zurueck();
    });

    if (window.ResizeObserver) {
      new ResizeObserver(zurueck).observe(liste);
    }
  }

  // Stellt sicher, dass Lampe und Ereignisse zur aktuell im Dokument
  // stehenden Kopfleiste gehoeren. Mehrfach aufrufbar - was schon
  // stimmt, wird nicht angefasst.
  function pruefe() {
    var r = document.querySelector('.header-menu__inner');
    if (!r) return;
    var l = r.querySelector('.overflow-menu');
    if (!l) return;

    rahmen = r;

    // Neue Liste bedeutet neue Knoten: die alten Anmeldungen sind mit
    // ihnen verschwunden und muessen neu gesetzt werden.
    if (liste !== l) {
      liste = l;
      bindeEreignisse();
    }

    if (!lampe || lampe.parentElement !== rahmen) {
      lampe = document.createElement('span');
      lampe.className = 'bsfa-lamp';
      lampe.setAttribute('aria-hidden', 'true');
      rahmen.appendChild(lampe);
    }

    aktiv = aktuellerLink();
    if (aktiv) aktiv.setAttribute('data-bsfa-aktiv', '');
    zurueck();
  }

  function start() {
    pruefe();

    // Erst wenn die Schrift wirklich geladen ist, stimmen die Breiten.
    // Ohne das sitzt die Lampe nach dem ersten Aufbau ein paar Pixel daneben.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(zurueck).catch(function () {});
    }

    if (window.MutationObserver) {
      var gruppe = document.getElementById('header-group');
      if (gruppe) {
        new MutationObserver(pruefe).observe(gruppe, {
          childList: true,
          subtree: true,
        });
      }
    }

    window.addEventListener('resize', zurueck);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Letzte Sicherung: nach dem vollstaendigen Laden noch einmal nachsehen.
  window.addEventListener('load', pruefe);
})();
